import { Component } from '@angular/core';
import { HttpProvider } from '../../providers/http/http';
import { App, NavController, ModalController, AlertController, Keyboard, Events, LoadingController, Platform, NavParams, MenuController, PopoverController, ToastController } from 'ionic-angular';
import { DomSanitizer } from '@angular/platform-browser';
import * as moment from 'moment';
moment.locale('es')
import { PedidoPage } from '../pedido/pedido';
import { ProductoPage } from '../producto/producto';
import { trigger, transition, useAnimation, state, style } from '@angular/animations';
import { tada } from 'ng-animate';
import { InAppBrowser } from '@ionic-native/in-app-browser';
// import { FileTransfer, FileTransferObject } from '@ionic-native/file-transfer';
import { DashboardPage } from '../dashboard/dashboard';
// import { File } from '@ionic-native/file';
import { PedidosPage } from '../pedidos/pedidos';
// import { FileOpener } from '@ionic-native/file-opener';
import { ImageLoader, ImageLoaderConfig } from 'ionic-image-loader';
import { MonedaPage } from '../moneda/moneda';
import { Cordova, cordovaWarn } from '@ionic-native/core';
import { File } from '@ionic-native/file';
import { FiltroAlmacenPage } from '../filtro-almacen/filtro-almacen';
@Component({
  selector: 'page-home',
  templateUrl: 'home.html',
  animations:[
    trigger('car',[
      state('open',style({
        'height': '5vh',
        'border-radius': '10px',
        'background-color': 'dodgerblue',
        'width': '5vh',
        'display': 'flex',
        'justify-content': 'center',
        'align-items': 'center' 
      })),
      state('close',style({
        'height': '5vh',
        'border-radius': '10px',
        'background-color': 'dodgerblue',
        'width': '5vh',
        'display': 'flex',
        'justify-content': 'center',
        'align-items': 'center'
      })),
      transition('open=>close',useAnimation(tada,{
        params:{
          timing:2
        }
      })),
      transition('close=>open',useAnimation(tada,{
        params:{
          timing:2
        }
      }))
    ])
  ]
})
export class HomePage {
  aux: any = []
  productos: any = []
  path:string=this.http.images
  pathPdf:string=this.http.pdf
  codigo: any = ''
  busqueda: any = ''
  timeout: any = ''
  loading: any = false
  add:any = false
  pedido:any = {}
  items: any = []
  cant: any = 0
  mostrarbarra: boolean = true
  actSearch = false
  cliente : any
  catalogo: any = null
  catalogo1: any = null
  catalogo2: any = null
  mensajes : any = []
  resBusq : any = []
  filtroA: any = 'TODOS'
  skip: any = 0
  fin = 9
  skip_buscar: any = 10
  menu = false
  loadModal: any
  police = false
  selectOptionsUnidad: any = {
    title: 'Unidades',
  }
  selectOptionsPrecio: any = {
    title: 'Precios',
  }
  selectOptionsAlmacen: any = {
    title: 'Almacenes',
  }
  moneda: any = 'USD'
  imgbig:any = []
  showbig:any = false
  fechaAct: any
  timer: any
  cargando = false
  successs = false
  errorr = false
  constructor(
    public navCtrl: NavController, 
    public http: HttpProvider,
    public imageLoader: ImageLoader,
    private imageLoaderConfig: ImageLoaderConfig,
    public loadingCtrl: LoadingController,
    public domsanitizer: DomSanitizer,
    public modal : ModalController,
    public toastCtrl: ToastController,
    public popCtrl: PopoverController,
    public file:File,
    // private transfer: FileTransfer,
    // private file: File,
    public alertCtrl: AlertController,
    public keyboard: Keyboard,
    private iab: InAppBrowser,
    public events : Events,
    public app: App,
    // private fileOpener: FileOpener,
    public platform : Platform,
    public navParams : NavParams,
    public menuCtrl : MenuController
    ){
    this.imageLoaderConfig.enableSpinner(true);
    this.imageLoaderConfig.setFallbackUrl('../../assets/imgs/image.png')
    events.subscribe('moneda:update', ()=>{
      this.updateMoneda()
    })
    if(window.localStorage.moneda){
      this.moneda = window.localStorage.moneda
    }
    if(!this.navParams.data.pedido) {
      this.menu = true
    }else{
      if (!this.navParams.data.espera) {
        if (window.localStorage.getItem('pedido')) this.pedido = JSON.parse(window.localStorage.getItem('pedido'))
        this.pedido.cliente = this.navParams.get('cliente')
        window.localStorage.setItem('pedido',JSON.stringify(this.pedido))
      }
    }
    this.mensajes = [
      "No se han encontrado artículos",
      "Verifica que los artículos tengan stock disponible",
      "Verifica que los artículos tengan precios asignados",
    ]
    events.subscribe('pedido:update',()=>{
      this.update()
    })

    this.events.publish('pedido:update')

    events.subscribe('close:exito',data=>{
      if(data === 'inicio'){
        this.navCtrl.setRoot(DashboardPage)
        this.navCtrl.popToRoot()
      }else{
        this.navCtrl.setRoot(PedidosPage)
        this.navCtrl.popToRoot()
      }
    })
    this.init()
  }

  checkdirectory(){
    this.file.checkFile(this.file.dataDirectory, 'avaflexproductos.json').then(data=>{
      console.log('Directory exists')
      return true
    }).catch(err => {
      console.log('Directory doesn\'t exist')
      return false
    });
  }
  async init(){
    // let exist =await this.file.checkFile(this.file.dataDirectory, 'avaflexproductos.json')
    // console.log(exist)
    let prod = '[]'
    this.cargando = true
    if(window.localStorage.getItem('productosferco')){
      prod = await this.file.readAsText(this.file.dataDirectory, 'avaflexproductos.json');
    }
    this.cargando = false
    let pro = JSON.parse(prod)
    if(pro && pro.length > 0){
      this.aux = JSON.parse(prod);
      for (let i = 0; i < this.aux.length; i++) {
        this.aux[i].precio = this.aux[i].precios[0]
      }
      this.items = this.aux.slice(this.skip, this.fin)
      this.skip += 10
      this.fin += 10
      this.initialize2()
    }else{
      this.initialize()
    }
  }
  updateMoneda(){
    if(window.localStorage.moneda){
      this.moneda = window.localStorage.moneda
    }
  }
  onImageLoad(event){
    // console.log(event)
    // console.log('cargada')
  }


  filtroAlmacen() {
    let modl = this.modal.create(FiltroAlmacenPage, {value: this.filtroA})
    modl.onDidDismiss(data => {
      if (data) {
        this.filtroA = data.value
        this.skip = 0
        this.fin = 9
        if (this.filtroA == "TODOS") {
          this.items = this.aux.slice(this.skip, this.fin)
        } else {
          this.items = this.aux.filter(el => {
            return el.almacen.some(alm => alm.trim() === this.filtroA.trim())
          }).slice(this.skip, this.fin)
        }
        this.skip += 10
        this.fin += 10
      }
    });
    modl.present();
  }

  showMonedas(){
    const pop = this.popCtrl.create(MonedaPage, {}, {cssClass: 'popppover'})
    pop.present()
  }

  checkPrice(prod){
    return prod.almacenes.some(e=>/^02/.test(e))
  }

  toggleMenu(){
    this.menuCtrl.toggle()
  }

  doInfinite(infiniteScroll) {
    if (!this.actSearch) {
      if (this.filtroA == "TODOS") {
        this.items = this.items.concat(this.aux.slice(this.skip, this.fin))
      } else {
        this.items = this.items.concat(this.aux.filter(el=>{
          return el.almacen.some(alm => alm.trim() === this.filtroA.trim())
        }).slice(this.skip, this.fin))
      }
    } else {
      this.items = this.items.concat(this.resBusq.slice(this.skip, this.fin))
    }
    this.skip += 10
    this.fin += 10
    infiniteScroll.complete();
  }

  ionViewDidLoad(){
    this.imageLoaderConfig.setMaximumCacheSize(20 * 1024 * 1024);
    this.imageLoaderConfig.setConcurrency(10);
    this.imageLoaderConfig.setImageReturnType('base64')
  }

  contar(){
    // let cant = 0
    // if(this.pedido.articulos){
    //   this.pedido.articulos.forEach(el=>{
    //     cant += parseFloat(el.cant)
    //   })
    // }
    this.cant = (this.pedido && this.pedido.articulos && this.pedido.articulos.length > 0) ? this.pedido.articulos.length : 0
  }

  update(){
    if(window.localStorage.getItem('pedido')){
      this.pedido = JSON.parse(window.localStorage.getItem('pedido'))
      this.contar()
    }
  }
  onFocus(item) {
    console.log("entro focus")
    if(item.cant == 0) {
      item.cant = null
    }
  }

  withOutFocus(item) {
    console.log("salio focus")
    if (!item.cant) {
      item.cant = 0
    }
  }

  validarP(prod) {
    console.log(prod)
    if (prod.equivalente === 1) {
      if (parseFloat(prod.cant) > prod.stockP) {
        prod.cant = prod.stockP
      }
    } else {
      if (parseFloat(prod.cant) > prod.stockS) {
        prod.cant = prod.stockS
      }
    }
  }

  asignarPrecio(index,$event){
    this.items[index].precio = parseInt($event)
  }
 
  async writeJSON(filename, object) {
    // object is the data you need to write as json
    // filename is the filename
    // no error checking done - just an example
    let save = await this.file.writeFile(this.file.dataDirectory, filename, JSON.stringify(object), {replace:true})
    window.localStorage.setItem('productosferco', 'true');
    console.log(save)
    return save
  }

  agregarItem(item){
    if (typeof item.cant === "string") parseFloat(item.cant)
    if (item.cant > 0) {
      event.stopPropagation();
      let pedido :any = {}
      if(window.localStorage.getItem('pedido')){
        pedido = {
          ...JSON.parse(window.localStorage.getItem('pedido')),
          moneda: window.localStorage.moneda
        }
      }
      if(!this.pedido.articulos){
        pedido.articulos = []
      }
      if (this.pedido.articulos && this.pedido.articulos.length >= 25) {
        this.toastCtrl.create({
          duration: 4000,
          message:'Estimado cliente, ha sobrepasado el limite de productos por pedido.'
        }).present()
      } else {
        let val = pedido.articulos.findIndex(el=>el.co_art === item.co_art)
        if(val > -1){
          let cantid = parseFloat(pedido.articulos[val].cant) + parseFloat(item.cant)
          pedido.articulos[val].cant = cantid
          this.add = !this.add
        }else{
          pedido.articulos.push({
            ...item,
            precio : item.precio
          })
          this.add = !this.add
        }
        this.pedido = pedido
        window.localStorage.setItem('pedido',JSON.stringify(pedido))
        this.contar()
        item.cant = 0
      }
    } else {
      this.toastCtrl.create({
        duration: 4000,
        message:'La cantidad del producto debe ser mayor que 0 para agregarlo al carrito.'
      }).present()
    }
  }

  agregar(prod){
    if(this.items[prod].cant) {
      this.items[prod].cant++
    } else this.items[prod].cant = 1
    // if(this.items[prod].cant){
    //   if(this.items[prod].cant < this.disponibilidad(this.items[prod], this.items[prod].unidad)){
    //     this.items[prod].cant++
    //   }
    // }else{
    //   if(this.items[prod].cant < this.disponibilidad(this.items[prod], this.items[prod].unidad) ){
    //     if (this.disponibilidad(this.items[prod], this.items[prod].unidad) < 1) {
    //       this.items[prod].cant = this.disponibilidad(this.items[prod], this.items[prod].unidad)
    //     } else this.items[prod].cant = 1
    //   } else {
    //     this.toastCtrl.create({
    //       duration: 4000,
    //       message:'Este producto no esta disponible en esta unidad'
    //     }).present()
    //   }
    // }
  }

  restar(prod){
    if(this.items[prod].cant){
      if(this.items[prod].cant > 0 ){
        this.items[prod].cant--
      }
    }else{
      this.items[prod].cant = 0
    }
  }
  agrandar(i, cod){
    this.imgbig = cod
    this.showbig = true
  }

  close(){
    this.showbig = false
  }

  irCarrito(){
    this.navCtrl.push(PedidoPage)
  }

  irProducto(item){
    this.navCtrl.push(ProductoPage,{producto:item})
  }

  doRefresh(refresher){
    this.mostrarbarra =  false
    this.imageLoader.clearCache();
    setTimeout(()=>{
      this.mostrarbarra = true
      refresher.complete()
    },2000)
  }

  disponibilidad(item, unidad) {
    let equi
    for (let i = 0; i < item.unidades.length; i++) {
      if (unidad === item.unidades[i]) {
        equi = i
      }
    }
    if (equi === 0) {
      return item.stockP
    }else {
      return Math.round(item.stockP / item.equivalencia[equi])
    }
  }

  disponibilidadSel(item, unidad, stock) {
    let equi
    for (let i = 0; i < item.unidades.length; i++) {
      if (unidad === item.unidades[i]) {
        equi = i
      }
    }
    if (equi === 0) {
      return stock
    }else {
      return Math.round(stock / item.equivalencia[equi])
    }
  }

  compareWithFn(o1, o2) {
    return o1 && o2 ? o1.warehouse === o2.warehouse && o1.stock === o2.stock : o1 === o2;
  }

  handleCantBlur(prod) {
    if (!prod.cant || prod.cant == 0) {
      prod.cant = 0;
    } else {
      const disponible = this.disponibilidad(prod, prod.unidad);
      if (prod.cant > disponible) {
        prod.cant = disponible;
      }
      // Asegurar que sea numérico
      prod.cant = parseFloat(prod.cant);
    }
  }

  onWarehouseChange(prod) {
    if (prod.selectedWarehouse) {
      const stock = prod.selectedWarehouse.stock;
      prod.stockS = stock;
      prod.stockP = stock;
      prod.currentWarehouse = prod.selectedWarehouse.warehouse;
    }
  }

  cambiarPre(item) {
    this.police = !this.police
    item.cant = 0
    let equi
    for (let i = 0; i < item.unidades.length; i++) {
      if (item.unidad === item.unidades[i]) {
        equi = i
      }
    }
    item.equivalente = item.equivalencia[equi]
    if (equi === 0) {
      item.stockS = item.stockP
    }else {
      item.stockS = Math.round(item.stockP * item.equivalente)
    }
  }

  montoReal(monto, iva, equiv) {
    return monto / equiv
  }

  montoReal3(monto, iva, equiv) {
    let val = monto * equiv
    let val2 = val.toFixed(2).replace('.', ',')
    return val2
  }

  montoReal2(monto, iva, equiv) {
    let val = monto * equiv
    let val2 = val.toString().split('.')
    if(val2.length > 1) return val2[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") + ','+ val2[1].slice(0,2);
    return val2[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.")
  }

  verM(item) {
    console.log(item)
  }

  ionViewDidEnter() {
    this.update()
    if(window.localStorage.getItem('network') === '1') {
      this.http.get('productos/catalogo').subscribe(
        (res:any)=>{
          this.catalogo = res
      })
      this.http.get('productos/catalogo1').subscribe(
        (res:any)=>{
          this.catalogo1 = res
      })
      this.http.get('productos/catalogo2').subscribe(
        (res:any)=>{
          this.catalogo2 = res
      })
    }
  }

  ActivarLoading() {
    this.loadModal = this.loadingCtrl.create({
      content: 'Por favor espere...'
    });
    this.loadModal.present();
  }
  DesactivarLoading() {
    this.loadModal.dismiss();
  }

  abrirPdf() {
    let btn = []
    if (this.catalogo) {
      btn.push(
        {
          text: 'Completo',
          handler: () => {
            this.iab.create(this.pathPdf + this.catalogo, '_system', 'location=no');
          }
        }
      )
    }
    if (this.catalogo1) {
      btn.push(
        {
          text: 'Precio 01',
          handler: () => {
            this.iab.create(this.pathPdf + this.catalogo1, '_system');
          }
        }
      )
    }
    if (this.catalogo2) {
      btn.push(
        {
          text: 'Precio 02',
          handler: () => {
            this.iab.create(this.pathPdf + this.catalogo2, '_system');
          }
        }
      )
    }
    this.alertCtrl.create({
      title: 'Selección de PDF',
      buttons: btn
    }).present();
    // this.iab.create(this.pathPdf + this.catalogo, '_system');
    // this.ActivarLoading()
    // const url = this.pathPdf + this.catalogo // keep your s3 bucket pdf file url
    // const fileName = 'catalogoFercoven'
    // const fileTransfer: FileTransferObject = this.transfer.create();
    // const dir_name = 'Download/'; //mention the directory where you want to download in the device
    // let path = '';
    // const result = this.file.createDir(this.file.externalRootDirectory, dir_name, true);
    // result.then((resp) => {
    //   path = resp.toURL();
    //   fileTransfer.download(url, path + fileName + '.pdf').then((entry) => {
    //     console.log('download complete: ' + entry.toURL());
    //     this.DesactivarLoading()
    //     this.toastCtrl.create({
    //       duration: 4000,
    //       message:'Descarga completa'
    //     }).present()
    //     this.fileOpener.open(entry.toURL(), 'application/pdf')
    //     .then(() => console.log('File is opened'))
    //     .catch(e => console.log('Error opening file', e));
    //   })
    //   .catch(err=> {
    //     console.log(err)
    //     this.DesactivarLoading()
    //     this.toastCtrl.create({
    //       duration: 4000,
    //       message:'Problemas al descargar el pdf'
    //     }).present()
    //   })
    // });
  }

  initialize2(){
    if(window.localStorage.getItem('pedido')){
      this.pedido = JSON.parse(window.localStorage.getItem('pedido'))
      this.contar()
    }
    this.fechaAct = window.localStorage.getItem('horaProductos')
    if(window.localStorage.getItem('network') === '1') {
      this.cargando = true
      this.successs = false
      this.errorr = false
      this.http.get('productosCom').subscribe(
        (res:any)=>{
          res.map(el=>{
            el.cant = 0
            el.precio = {}
          })
          for (let i = 0; i < res.length; i++) {
            for (let j = 0; j < res[i].precios.length; j++) {
              let el2 = res[i].precios[j];
              el2.monto = parseFloat(parseFloat(el2.monto).toFixed(2))
            }
            const stockInicial = res[i].stock[0];
            res[i].stockP = res[i].stockS = stockInicial;
            res[i].selectedWarehouse = {
                stock: stockInicial,
                warehouse: res[i].almacen[0],  // Almacén por defecto
                index: 0
            };
            res[i].currentWarehouse = res[i].almacen[0];
            res[i].unidad = res[i].unidades[0]
            res[i].equivalente = res[i].equivalencia[0]
            res[i].precio = res[i].precios[0]
          }
          let save = this.writeJSON('avaflexproductos.json', res)
  
          this.aux = res.slice();
          window.localStorage.setItem('horaProductos', moment().format('DD-MM-YYYY H:mm A'));
          this.fechaAct = window.localStorage.getItem('horaProductos')
          this.cargando = false
          this.successs = true
        }, err => {
          this.errorr = true
          this.cargando = false
        })
    } else {
      this.errorr = true
      this.cargando = false
      // this.alertCtrl.create({
      //   title: 'Atención',
      //   subTitle:'No se encuentra conexión con ninguna red.',
      //   buttons:[
      //     {
      //       text:'Aceptar',
      //       cssClass:'btnAceptar',
      //       handler:()=>{
      //       }
      //     }
      //   ]
      // }).present()
    }
  }
  
  initialize() {
    if(window.localStorage.getItem('pedido')){
     
      this.pedido = JSON.parse(window.localStorage.getItem('pedido'))
      this.contar()
    }
    if(window.localStorage.getItem('network') === '1'){
      this.ActivarLoading()
      this.cargando = true
      this.successs = false
      this.errorr = false
      this.http.get('productosCom').subscribe(
        (res:any)=>{
          this.DesactivarLoading()
          res.map(el=>{
            el.cant = 0
            el.precio = {}
          })
          for (let i = 0; i < res.length; i++) {
            for (let j = 0; j < res[i].precios.length; j++) {
              let el2 = res[i].precios[j];
              el2.monto = parseFloat(parseFloat(el2.monto).toFixed(2))
            }
            const stockInicial = res[i].stock[0];
            res[i].stockP = res[i].stockS = stockInicial;
            res[i].selectedWarehouse = {
                stock: stockInicial,
                warehouse: res[i].almacen[0],  // Almacén por defecto
                index: 0
            };
            res[i].currentWarehouse = res[i].almacen[0];
            res[i].unidad = res[i].unidades[0]
            res[i].equivalente = res[i].equivalencia[0]
            res[i].precio = res[i].precios[0]
          }
          let save = this.writeJSON('avaflexproductos.json', res)
          this.aux = res.slice();
          this.items = this.aux.slice(this.skip, this.fin)
          this.skip += 10
          this.fin += 10
          window.localStorage.setItem('horaProductos', moment().format('DD-MM-YYYY H:mm A'));
          this.fechaAct = window.localStorage.getItem('horaProductos')
          this.cargando = false
          this.successs = true
        },
        error=>{
          this.errorr = true
          this.cargando = false
          console.log(error)
          this.DesactivarLoading()
        }
      )
    } else {
      this.errorr = true
      this.cargando = false
      // this.alertCtrl.create({
      //   title: 'Atención',
      //   subTitle:'No se encuentra conexión con ninguna red.',
      //   buttons:[
      //     {
      //       text:'Aceptar',
      //       cssClass:'btnAceptar',
      //       handler:()=>{
      //       }
      //     }
      //   ]
      // }).present()
    }
  }

  buscar() {
    const searchTerms = this.busqueda.toLowerCase().split(' ');
    const isMultiWord = searchTerms.length > 1;

    this.resBusq = this.aux.filter(result => {
      // Normalizamos los campos de búsqueda
      const normalizedFields = {
        art_des: result.art_des ? result.art_des.toLowerCase() : '',
        co_art: result.co_art ? result.co_art.toLowerCase() : '',
        ref: result.ref ? result.ref.toLowerCase() : ''
      };

      // Primero verificamos el filtro de almacén
      if (this.filtroA !== "TODOS") {
        if (!result.almacen || !result.almacen.some(alm => alm.trim() === this.filtroA.trim())) {
          return false;
        }
      }

      // Función para buscar en un campo específico
      const matchInField = (fieldValue: string, term: string) => {
        return fieldValue.indexOf(term) > -1;
      };

      if (!isMultiWord) {
        // Búsqueda simple de una palabra
        const searchTerm = this.busqueda.toLowerCase();
        return matchInField(normalizedFields.art_des, searchTerm) ||
               matchInField(normalizedFields.co_art, searchTerm) ||
               (result.ref && matchInField(normalizedFields.ref, searchTerm));
      }

      // Búsqueda de múltiples palabras
      const matches = {
        art_des: 0,
        co_art: 0,
        ref: 0
      };

      searchTerms.forEach(term => {
        if (matchInField(normalizedFields.art_des, term)) matches.art_des++;
        if (matchInField(normalizedFields.co_art, term)) matches.co_art++;
        if (result.ref && matchInField(normalizedFields.ref, term)) matches.ref++;
      });

      // Calculamos la puntuación para el ordenamiento
      result.puntuacion = Math.max(matches.art_des, matches.co_art, matches.ref);

      // Retornamos true si algún campo contiene todas las palabras
      return Object.values(matches).some(count => count === searchTerms.length);
    });

    // Ordenamos por puntuación
    this.resBusq.sort((a, b) => (b.puntuacion || 0) - (a.puntuacion || 0));

    // Actualizamos la paginación
    this.skip = 0;
    this.fin = 9;
    this.items = this.resBusq.slice(this.skip, this.fin);
    this.skip += 10;
    this.fin += 10;
    this.actSearch = true;
  }
  reset(){
    if(this.busqueda.length < 1) {
      this.actSearch = false
      if (this.filtroA == "TODOS") {
        this.items = this.aux.slice(0, 9)
      } else {
        this.items = this.aux.filter(el=>{
          return el.almacen.some(alm => alm.trim() === this.filtroA.trim())
        }).slice(0, 9)
      }
      this.skip = 10
      this.fin = 19
    }
  }

  verStock(prod) {
    const prompt = this.alertCtrl.create({
      title: 'Validación',
      message: "Ingrese el código para ver el stock real.",
      inputs: [
        {
          name: 'codigo',
          placeholder: 'Codigo'
        },
      ],
      buttons: [
        {
          text: 'Cancel',
          handler: data => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Save',
          handler: data => {
            if (data && data.codigo && data.codigo == "7880") {
              prod.seeStockR = true;
              this.aux.forEach(el=>{
                el.seeStockR = true;
              })
            }
          }
        }
      ]
    });
    prompt.present();
  }

  mostrarStock(stock) {
    const s = parseFloat(stock);
    let categoria;

    if (s > 200) {
      categoria = 'mayor200';
    } else if (s > 100) {
      categoria = 'mayor100';
    } else if (s > 80) {
      categoria = 'mayor80';
    } else if (s > 60) {
      categoria = 'mayor60';
    } else if (s > 40) {
      categoria = 'mayor40';
    } else if (s >= 20) {
      categoria = 'mayor20';
    } else if (s >= 10) {
      categoria = 'menor20';
    } else if (s >= 5) {
      categoria = 'menor10';
    } else if (s >= 0) {
      categoria = 'menor5';
    } else {
      categoria = 'menor0';
    }

    switch (categoria) {
      case 'mayor200':
        return "Mayor a 200 Und";
      case 'mayor100':
        return "Mayor a 100 Und";
      case 'mayor80':
        return "Mayor a 80 Und";
      case 'mayor60':
        return "Mayor a 60 Und";
      case 'mayor40':
        return "Mayor a 40 Und";
      case 'mayor20':
        return "Mayor a 20 Und";
      case 'menor20':
        return "Menor a 20 Und";
      case 'menor10':
        return "Menor a 10 Und";
      case 'menor5':
        return "Menor a 5 Und";
      case 'menor0':
        return "Menor a 0 Und";
      default:
        return "Valor inválido";
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts